import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import ImageUploadModal from 'common/components/modal/image_upload_modal';

/**
 * Profile's avatar.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class Avatar extends Component {

  constructor(props) {
    super(props)
    this.state = {showingModal: false, selectedImage: ''}
    this.update = this.update.bind(this)
    this.toggleImageUploader = this.toggleImageUploader.bind(this)
  }

  componentDidMount() {
    /* set initial value based on user profile data if empty */
    const { avatar, user, updateLocal } = this.props

    if (!avatar) {
      updateLocal(user.profile_data.avatar)
    }
  }

  update(avatar) {
    const {user: {profile_data}, updateUser} = this.props
    updateUser(Object.assign(
      {id: profile_data.id},
      /* format image URI according to the format expected in the server */
      {avatar: avatar.split(',').pop()}
    ))
  }

  toggleImageUploader() {
    const {showingModal} = this.state
    this.setState({showingModal: !showingModal, selectedImage: ''})
  }

  render() {
    const { showingModal, selectedImage } = this.state
    const { user, updateLocal, avatar, hide } = this.props
    const error = user.error && user.error.avatar? user.error.avatar[0]:''

    return (
      <section className={classnames("avatar-upload", { hide })}>
        <h3>Profile Image</h3>

        <p>
          This image will display next to your entries, comments, and at the top of your
          profile page. You can use your photo or your logo.
        </p>

        <Link className="sample-link" to="/users/cdavisdesigns/" target="_blank">
          View Sample Profile
        </Link>

        {avatar?
        <div>
          <img src={avatar} className="avatar avatar-lg" /><br/>
          <button className="btn btn-md btn-text" onClick={this.toggleImageUploader}>
            Change
          </button>
        </div>:
        <div className="empty" onClick={this.toggleImageUploader}>
          <i className="fa fa-camera"></i>
          Add Profile Image
        </div>}

        {error && <div className="text-danger">{error}</div>}

        <ImageUploadModal
          minWidth={140}
          minHeight={140}
          cropperRatio={1}
          show={showingModal}
          preCrop={selectedImage}
          selectImage={(img) => this.setState({selectedImage: img})}
          onCrop={(img) => {updateLocal(img); this.update(img);}}
          toggleModal={this.toggleImageUploader}/>

      </section>
    );
  }
}

Avatar.propTypes = {
  user: PropTypes.object,
  avatar: PropTypes.string,
  updateUser: PropTypes.func,
  updateLocal: PropTypes.func,
  hide: PropTypes.bool,
};

export default Avatar;



// WEBPACK FOOTER //
// ./registration/creative/components/avatar.jsx